import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {OverlayComponentMrGreenBox} from "./overlay.component.mrgreen.box";
import {OverlayComponentDefaultBox} from "./overlay.component.default.box";

export const OverlayComponentBox = styledByTheme(OverlayComponentDefaultBox)
    .forMrGreen(OverlayComponentMrGreenBox)
    .apply();
